import { useEffect, useState } from "react";
import api from "../lib/api";
import { devWarn } from "../lib/log";

// While searching Your Ducks: how many ducks match in each flock (GET /mine/match-counts), so only flocks with a match
// are shown, all expanded. Collapsing one during a search is temporary; clearing the search restores the saved state.
export const useFlockSearch = (query, enabled) => {
  const [counts, setCounts] = useState(null);
  const [folded, setFolded] = useState({});
  const key = JSON.stringify(query);
  const searching = enabled && !!query.q;

  useEffect(() => {
    setFolded({});
    setCounts(null);
    if (!searching) return undefined;
    let alive = true;
    const params = Object.fromEntries(Object.entries(JSON.parse(key)).filter(([, v]) => v));
    api
      .get("/mine/match-counts", { params })
      .then((r) => alive && setCounts(r.data))
      .catch((e) => {
        devWarn("Your Ducks match counts failed", e?.message);
        if (alive) setCounts({ failed: true });
      });
    return () => {
      alive = false;
    };
  }, [key, searching]);

  const ready = searching && !!counts && !counts.failed;
  const matchesOf = (k) => (k === "unsorted" ? counts?.unsorted : counts?.flocks?.[k]) || 0;
  return { searching, ready, counts, matchesOf, folded, fold: (k) => setFolded((f) => ({ ...f, [k]: !f[k] })) };
};
